module.exports = __webpack_public_path__ + "static/img/banner_opensourse.f0713dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/home/imgs/head-banner/banner_opensourse.jpg
// module id = w+Qv
// module chunks = 0